<!-- eslint-disable vue/max-attributes-per-line -->
<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6"
                 :sm="12"
                 v-if="this.$store.state.user.info.systemAdmin">
            <a-form-item label="水司">
              <a-select placeholder="请选择"
                        v-model="query.tenantId"
                        allow-clear>
                <a-select-option v-for="item in tenantList"
                                 :key="item.tenantId"
                                 :value="item.tenantId">{{
                                   item.tenantName
                                 }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="6"
                 :sm="12">
            <a-form-item label="设备名称">
              <a-select placeholder="请选择设备名称"
                        v-model="query.ruleName"
                        allow-clear>
                <a-select-option v-for="(item, index) in ruleNameList"
                                 :key="index"
                                 :value="item">
                  {{ item }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="6"
                 :sm="12">
            <a-form-item label="规则类型">
              <a-select placeholder="请选择规则类型"
                        v-model="query.ruleType"
                        allow-clear>
                <a-select-option value="特征点">特征点</a-select-option>
                <a-select-option value="附属物">附属物</a-select-option>
                <a-select-option value="构造物">构造物</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="6"
                 :sm="12">
            <a-form-item label="规则编码">
              <a-input v-model="query.ruleCode"
                       placeholder="请输入规则编码"
                       allow-clear />
            </a-form-item>
          </a-col>
        </a-row>

        <a-row :gutter="48">
          <a-col :md="8"
                 :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary"
                        @click="queryList">查询</a-button>
              <a-button style="margin-left: 8px"
                        @click="resetList">重置</a-button>
              <a-button type="primary"
                        style="margin-left: 8px"
                        @click="addOrUpdateHandle()"
                        v-action:add>新增</a-button>
              <a-button type="danger"
                        style="margin-left: 8px"
                        @click="deleteSelectRow()"
                        v-action:del>删除</a-button>
              <a-button type="primary"
                        style="margin-left: 8px"
                        @click="downloadTemplate({ excelForm: true })"
                        v-action:upload>下载模板</a-button>
              <a-button type="primary"
                        style="margin-left: 8px"
                        @click="exportHandle()"
                        :loading="exportLoading"
                        v-action:export>导出</a-button>
              <a-button type="primary"
                        style="margin-left: 8px"
                        :loading="importLoading"
                        @click="importHandle"
                        v-action:import>
                <a-icon type="upload" />导入
              </a-button>
              <a-button type="primary"
                        icon="hdd"
                        style="margin-left: 8px"
                        @click="recycleBinVisible = true"
                        v-action:recycle>回收站</a-button>
              <a-button type="primary"
                        style="margin-left: 8px"
                        @click="clear"
                        v-action:clear>一键清空数据</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table size="middle"
             rowKey="id"
             bordered
             :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
             :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
             :data-source="list"
             :columns="columns"
             :loading="dataListLoading"
             :pagination="pagination"
             @change="pageChange">
      <a-tag color="blue"
             slot="status"
             slot-scope="text">{{ text ? 'yes' : 'NO' }}</a-tag>
      <span slot="createTime"
            slot-scope="text">{{ moment(text).format('YYYY-MM-DD') }}</span>
      <span slot="action"
            slot-scope="text, record">
        <a @click="addOrUpdateHandle(record.id)"
           v-action:edit>编辑</a>
      </span>
    </a-table>
    <a-modal title="操作"
             style="top: 20px"
             :width="800"
             :maskClosable="false"
             v-model="addOrUpdateVisible"
             @ok="handleOk"
             @cancel="handleCancel">

      <a-form class="tenant-form"
              :form="addOrUpdateForm">
        <a-form-item :labelCol="labelCol"
                     :wrapperCol="wrapperCol"
                     label="设备名称"
                     hasFeedback>
          <a-input placeholder="请输入设备名称"
                   v-decorator="['ruleName', { rules: [{ required: true, message: '设备名称' }] }]" />
        </a-form-item>

        <a-form-item :labelCol="labelCol"
                     :wrapperCol="wrapperCol"
                     label="规则类型">
          <a-select placeholder="请选择规则类型"
                    v-decorator="['ruleType', { initialValue: '特征点'}]">
            <a-select-option value="特征点">特征点</a-select-option>
            <a-select-option value="附属物">附属物</a-select-option>
            <a-select-option value="构造物">构造物</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item :labelCol="labelCol"
                     :wrapperCol="wrapperCol"
                     label="规则编码"
                     hasFeedback>
          <a-input placeholder="请输入规则编码"
                   v-decorator="['ruleCode', { rules: [{ required: true, message: '规则编码' }] }]" />
        </a-form-item>

      </a-form>
    </a-modal>

    <importModal ref="importModal"
                 :tree-data="road"
                 exportUrl="/pipe-network/gis/pipe-networks/import"
                 @close="close"
                 @reLoad="resetList"></importModal>
    <RecycleBinModal :visible.sync="recycleBinVisible"
                     @ok="modalFormOk"></RecycleBinModal>
  </a-card>
</template>

  <script>
import mixinViewModule from '@/mixin/common'
import { PERMISSION_ENUM } from '@/core/permission/permission'
import importModal from './module/ImportModalNotZone.vue'
import RecycleBinModal from './module/NewPipeNetworkRecycleBinModal'
import { listPipeNetworkByGroupProperties, getPipeDiameterSizeOptions, getPipeLineMaterialOptions } from '@/api/manage'
import moment from 'moment'
import { handleImportBlobResponse } from '@/utils/importUtils'

const STATUS = {
  1: '正常',
  2: '禁用'
}

const columns = [
  {
    title: '设备名称',
    dataIndex: 'ruleName'
  },
  {
    title: '设备类型',
    dataIndex: 'ruleType'
  },
  {
    title: '规则编码',
    dataIndex: 'ruleCode'
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    scopedSlots: { customRender: 'createTime' }
  },

  {
    title: '操作',
    width: '150px',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' }
  }
]

export default {
  mixins: [mixinViewModule],
  name: 'GisPipeNetworkRule',
  components: {
    importModal,
    RecycleBinModal
  },
  data () {
    return {
      PointList: [],
      LineList: [],
      recycleBinVisible: false,
      zoneId: '',
      openSelectFile: false,
      importLoading: false,
      fileList: [],
      queryUrl: 'pipe-network/gis/pipe-networks/rule/page',
      addOrUpdateUrl: 'pipe-network/gis/pipe-networks/rule',
      queryOneUrl: 'pipe-network/gis/pipe-networks/rule',
      deleteUrl: 'pipe-network/gis/pipe-networks/rule',
      queryZoneDateUrl: 'zone-metering/zone-metering',
      exportDataUrl: 'pipe-network/gis/pipe-networks/export',
      exportFileName: '物探点数据.xlsx',
      downloadTemplateUrl: 'pipe-network/gis/pipe-networks/template/download',
      downloadTemplateName: '物探点数据导入模板.xlsx',

      ruleNameList: [],
      ruleTypeList: [],
      pipeLineMaterialOptions: [], // 管线材质选项
      pipeDiameterSizeOptions: [], // 管径大小选项
      featurePointOptions: [], // 特征选项
      appendageOptions: [], // 附属物选项
      structureOptions: [], // 构筑物选项
      road: [], // 分区数据选项
      query: {
        ruleName: '', // 设备名称
        ruleType: '', // 规则类型
        ruleCode: '', // 规则编号
        tenantId: this.$store.state.user.info.tenantId
      },
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' }),
      labelCol: { span: 8 },
      wrapperCol: { span: 12 },
      columns
    }
  },
  filters: {
    statusFilter (key) {
      return STATUS[key]
    },
    permissionFilter (key) {
      const permission = PERMISSION_ENUM[key]
      return permission && permission.label
    },
    formatDate (time) {
      const date = new Date(time)
      return formatDate(date, 'YYYY-MM-DD HH:mm:ss')
    }
  },
  created () {
    this.listPipeLineMaterialOptions()
    this.listPipeDiameterSizeOptions()
    this.getFeaturePointOptions()
    this.getAllTenant()
    this.getZoneData()
    this.getPointList()
    this.getLineList()
    this.resetList()
    this.setSystemName()
    this.getRuleNameList()
  },
  methods: {
    getRuleNameList () {
      this.$http.get('/pipe-network/gis/pipe-networks/rule/get-rule-name').then(res => {
        console.log(res.data)
        this.ruleNameList = res.data
      })
    },
    setSystemName () {
      this.$store.commit('SET_SYSTEMNAME', `${this.$store.getters.userInfo.realName}管网GIS系统`)
    },
    resetList () {
      if (this.query.sysType) {
        const params = {
          sysType: this.query.sysType
        }
        this.query = params
      } else {
        this.query = {}
      }

      this.pagination.current = 1
      this.selectedRows = []
      this.queryList()
    },
    moment,
    clear () {
      this.$confirm({
        title: '清空数据',
        content: `您确定要清空所有数据吗？`,
        centered: true,
        onOk: () => {
          this.$http.put('/pipe-network/gis/pipe-networks/empty/pipe/network').then((res) => {
            if (res.code == 0) {
              this.$message.success('操作成功')
              this.queryList()
            }
          })
        }
      })
    },
    getLineList () {
      const params = {
        dictCode: 'PIPING_MATERIAL'
      }
      this.$http.get('/manager/dicts/children', { params }).then(({ data }) => {
        this.LineList = data
      })
    },
    getPointList () {
      const params = {
        dictCode: 'FEATURE_POINTS'
      }
      this.$http.get('/manager/dicts/children', { params }).then(({ data }) => {
        this.PointList = data
      })
    },
    modalFormOk () {
      this.queryList()
    },
    // 关闭选择分区页面时
    close (val) {
      console.log(val)
      this.zoneId = val
      this.openSelectFile = true
    },
    importHandle () {
      this.$refs.importModal.show()
    },
    changeFile (info) { },
    customRequest (data) {
      const formData = new FormData()
      formData.append('file', data.file)
      formData.append('zone_id', this.zoneId)
      this.saveFile(formData)
    },
    getZoneData () {
      this.$http.get(this.queryZoneDateUrl).then(({ data }) => {
        this.zoneTreeData = data
      })
    },
    saveFile (formData) {
      this.importLoading = true
      this.axios({
        method: 'post',
        url: '/pipe-network/gis/pipe-networks/import',
        headers: {},
        params: {},
        data: formData,
        responseType: 'blob'
      })
        .then((response) => handleImportBlobResponse(response, { errorFileName: '管点导入失败数据.xlsx' }))
        .then(({ hasErrorFile, message }) => {
          this.queryList()
          if (hasErrorFile) {
            this.$message.warning(message)
          } else {
            this.$message.success(message)
          }
        })
        .catch((error) => {
          this.$message.error(error.message || '导入失败')
        })
        .finally(() => {
          this.importLoading = false
        })
    },
    listPipeLineMaterialOptions () {
      listPipeNetworkByGroupProperties('texture_material').then(({ data }) => {
        this.pipeLineMaterialOptions = data
      })
    },
    listPipeDiameterSizeOptions () {
      listPipeNetworkByGroupProperties('caliber').then(({ data }) => {
        this.pipeDiameterSizeOptions = data
      })
    },
    getFeaturePointOptions () {
      listPipeNetworkByGroupProperties('feature_point').then(({ data }) => {
        this.featurePointOptions = data
      })

      listPipeNetworkByGroupProperties('appendage').then(({ data }) => {
        this.appendageOptions = data
      })

      listPipeNetworkByGroupProperties('structure').then(({ data }) => {
        this.structureOptions = data
      })
    }
  },
  watch: {}
}
  </script>

  <style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}

.tenant-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}

/deep/.ant-table-thead > tr > th > {
  text-align: center;
}

/deep/.ant-table-tbody > tr > td {
  text-align: center;
}
</style>
